module.exports = function() {
  return new Worker(__webpack_public_path__ + "787bf0295c6d00239a8d.worker.js");
};